<template lang="pug">
  div.horizontal
    div(v-if="i !== 0 && i !== slits.length && n.outRange !== false",v-for="(n , i) in slits")
      button.tgl(@mousedown="mousedown",@touchstart="mousedown",:data-key="i",:style="sty(n)")
        img(src="@/assets/ico_lr.svg")
        div.del 削除
        div.bln {{ Math.round(mm) * 10 }}mm
</template>

<script>
import store from '../../stores/index';
export default {
  name: 'Vertical',
  components: {
  },
  data () {
    return {
      slits: [],
      dis: [],
      items: [],
      isCheckItem: false
    };
  },
  computed: {
  },
  watch: {
    number () {
      if (this.sets[this.number] !== undefined) {
        this.slits = this.sets[this.number].slits;
      }
    },
    sets () {
      if (this.sets[this.number] !== undefined) {
        this.slits = this.sets[this.number].slits;
      }
    }
  },
  methods: {
    sty (n) {
      this.mm = n.pos;
      return { left: (this.c2p(n.pos)) + 'px' };
    },
    mousedown (e) {
      let me = this;
      me.flg = true;
      me.$tar = e.currentTarget;
      me.posSX = me.$tar.offsetLeft || 0;
      me.posSY = me.$tar.offsetTop || 0;
      me.startX = this.mp(e).clientX;
      me.startY = this.mp(e).clientY;
      for (let i = 0; i < this.slits.length; i++) {
        this.dis[i] = this.slits[i].pos - this.p2c(me.posSX);
      }
      me.cnt = Number(me.$tar.getAttribute('data-key'));
      if (this.slits.length > 2) {
        if (this.cnt === this.slits.length - 1) {
          me.items = this.slits[this.cnt - 2].item;
          me.isCheckItem = this.items.some(item => {
            return item.code.includes('KS');
          });
        } else {
          me.items = this.slits[me.cnt].item || this.slits[this.cnt - 2].item;
          me.isCheckItem = this.items.some(item => {
            return item.code.includes('KS');
          });
        }
      }
      window.addEventListener('mousemove', this.mousemove, false);
      window.addEventListener('mouseup', this.mouseup, false);
      window.addEventListener('touchmove', this.mousemove, false);
      window.addEventListener('touchend', this.mouseup, false);
    },
    mousemove (e) {
      this.posX = Math.round((this.mp(e).clientX - this.startX) / 50) * 50 + this.posSX;
      const items = this.slits[this.cnt - 2] ? this.slits[this.cnt - 2].item : this.slits[this.cnt - 1].item;
      const mm = this.slits[this.cnt - 1].span + this.slits[this.cnt - 2] ? this.slits[this.cnt - 2].span : 0;
      const itemCheck = items.some(item => item.code.includes('KS'));
      const rangeMinSlit = itemCheck ? 50 : 150;
      if (this.cnt !== 0) {
        let prevPos = this.c2p(this.slits[this.cnt - 1].pos);
        if (this.posX - prevPos < rangeMinSlit) {
          this.posX = prevPos + 150;
        }
        if (this.posX - prevPos >= 300) {
          this.posX = prevPos + 300;
        }
      }
      if (this.slits.length > 2 && this.cnt >= 2) {
        if (itemCheck && mm > 75) {
          return false;
        }
      }
      this.posX = (Math.round(this.posX / 50) * 50);

      this.posY = Math.round(this.mp(e).clientY - this.startY) + this.posSY;

      if (this.posY <= -50 && this.slits.length > 2) {
        this.$tar.style.top = this.posY + 'px';
        this.$tar.classList.add('act');
      } else {
        this.$tar.style.top = 0 + 'px';
        this.$tar.classList.remove('act');
        if (this.prev !== this.posX) {
          this.update();
        }
      }
      this.prev = this.posX;
    },
    mouseup () {
      const itemCheck = this.slits[0].item.some(item => item.code.includes('KS'));
      const maxSlitsCheck = itemCheck ? this.slits.length > 3 : this.slits.length > 2;
      if (this.posY <= -50 && maxSlitsCheck) {
        this.set = this.sets[this.number];
        const deleteCount = this.isCheckItem ? 2 : 1;
        if (this.cnt === this.slits.length - 1) {
          this.slits[this.cnt - deleteCount].item = [];
          this.set.size.splice(0, 1, this.slits[this.cnt - deleteCount].pos);
        } else {
          let sp = this.isCheckItem ? this.slits[this.cnt + 1].span + this.slits[this.cnt].span : this.slits[this.cnt + 1].pos - this.slits[this.cnt].pos;
          for (let i = this.cnt + 1; i < this.slits.length; i++) {
            this.slits[i].pos = this.slits[i].pos - sp;
            this.slits.splice(i, 1, this.slits[i]);
            if (i === this.slits.length - 1) {
              this.set.size.splice(0, 1, this.slits[i].pos);
            }
          }
        }
        this.slits.splice(this.isCheckItem && this.cnt === this.slits.length - 1 ? this.cnt - 1 : this.cnt, deleteCount);
        this.sets.splice(this.number, 1, this.set);
      } else if (this.posY > -50 && this.slits[this.cnt - 1].outRange === false) {
        this.set = this.sets[this.number];
        const index = this.slits[this.cnt - 2].item.findIndex((code) => code.code.includes('KS'));
        const mm = this.slits[this.cnt - 1].span + this.slits[this.cnt - 2].span;
        let rate = mm > 60 ? 2 / 3 : 1 / 2;
        let slitPos = (this.slits[this.cnt].pos - this.slits[this.cnt - 2].pos) * rate + this.slits[this.cnt - 2].pos;
        if (mm >= 60 && mm <= 75) {
          this.slits.splice(this.cnt - 1, 1);
          let obj = {
            pos: mm > 60 ? slitPos - 5 : slitPos,
            item: [],
            floor: [],
            slit: {},
            outRange: false
          };
          this.slits.splice(this.cnt - 1, 0, obj);
          this.updateSlit(this.set);
        }
        if (mm > 75 || mm < 60) {
          this.slits[this.cnt - 2].item.splice(index, 1);
          this.slits.splice(this.cnt - 1, 1);
          const result = {
            message: mm > 75 ? 'TSセット(乾太くん用)は<br/>横幅600mm, 750mmの場合<br/>設置可能です' : 'TSセット(乾太くん用)は横幅600mm, 750mmの場合設置可能です',
            width: this.slits[this.cnt - 1].pos - this.slits[this.cnt - 2].pos,
            position: this.slits[this.cnt - 2].pos
          };
          store.commit('setMessageWarning', result);
        }
        this.sets.splice(this.number, 1, this.set);
      }
      this.$tar.style.top = 0 + 'px';
      this.$tar.classList.remove('act');
      window.removeEventListener('mousemove', this.mousemove, false);
      window.removeEventListener('mouseup', this.mouseup, false);
      window.removeEventListener('touchmove', this.mousemove, false);
      window.removeEventListener('touchend', this.mouseup, false);
    },
    update () {
      this.slits[this.cnt].pos = this.p2c(this.posX);
      this.set = this.sets[this.number];
      if (this.cnt === this.slits.length - 1) {
        this.set.size.splice(0, 1, this.p2c(this.posX));
      } else {
        for (let i = this.cnt + 1; i < this.slits.length; i++) {
          let poss = this.slits[this.cnt].pos + this.dis[i];
          this.slits[i].pos = (Math.round(poss / 15) * 15);
          this.slits.splice(i, 1, this.slits[i]);
          if (i === this.slits.length - 1) {
            this.set.size.splice(0, 1, this.slits[i].pos);
          }
        }
      }
      this.slits.splice(this.cnt, 1, this.slits[this.cnt]);
      this.rails.splice(0, 1, this.rails[0]);
      this.sets.splice(this.number, 1, this.set);
    }
  },
  created () {
  },
  mounted () {
    if (this.sets[this.number] !== undefined) {
      this.slits = this.sets[this.number].slits;
      this.rails = this.sets[this.number].rails;
    }
  }
};
</script>

<style lang="stylus" scoped>
  .horizontal
    position absolute
    left 0
    top 45px
    .tgl
      position absolute
      left 162px
      top 0
      transform translate(-50%,-50%)
      .bln
        position absolute
        left 50%
        bottom -50%
        transform translate(-50%,0)
        .preview &
          font-size 14px
      img
        pointer-events none
      .del
        display none
        position absolute
        left 50%
        transform translate(-50%,0)
        padding 5px 10px
        font-size 12px
        top -100%
        color #ffffff
        white-space nowrap
        border-radius 3px
        background-color #000000cc
      &:hover
        opacity 1
        img
          opacity 0.7
      &.act
        .del
          display block
</style>



// WEBPACK FOOTER //
// src/components/front/Horizontal.vue